import api from "@/libs/axios";
import * as ep from "../../../endpoints";

export default {
  namespaced: true,

  state: () => ({
    typeDecisions: [],
    decisions: [],
    nameDecisions: "",
    loading: false,
    loadingDecisions: false,
    pagination: {},
  }),
  getters: {
    typeDecisions(state) {
      return state.typeDecisions;
    },
    nameDecisions(state) {
      return state.nameDecisions;
    },
    decisions(state) {
      return state.decisions;
    },
    loading(state) {
      return state.loading;
    },
    loadingDecisions(state) {
      return state.loadingDecisions;
    },
    pagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setTypeDecisions(state, payload) {
      state.typeDecisions = payload;
    },
    setDecisions(state, payload) {
      state.decisions = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    getTypeDecisions(context, payload) {
      context.state.loading = true;
      api
        .get(ep.DECISIONS, {
          params: { page: payload.page, name: payload.name },
        })
        .then((res) => {
          context.commit("setTypeDecisions", res.data.data);
          context.commit("setPagination", res.data.pagination);
          context.state.loading = false;
        });
    },
    getDecisions(context, payload) {
      context.state.loadingDecisions = true;
      api
        .get(ep.DECISIONS_BY_ID(payload.id))
        .then((res) => {
          context.commit("setDecisions", res.data.data.regulations);
          context.state.nameDecisions = res.data.data.name_ar;
          context.state.loadingDecisions = false;
        })
        .catch(() => {
          context.state.loadingDecisions = false;
        });
    },
  },
};
